import React, { useState, useEffect } from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import moment from 'moment'

const MailFilterHistory = ({ filter, setFilter, onExportCSV, hasResults = false }) => {

  const [fromFilterInput, setfromFilterInput] = useState('')
  const [policyNumberInput, setPolicyNumberInput] = useState('')
  const [toMailInput, setToMailInput] = useState('')
  const [toDateInput, setToDateInput] = useState('')
  const [fromDateInput, setFromDateInput] = useState('')
  const [selectedFilterInput, setSelectedFilterInput] = useState('fromFilterSelection')

  const [exportCSV, setExportCSV] = useState(true)
  const [filterApplied, setFilterApplied] = useState(false)
  const handleSubmit = () => {
    let filterBody

    if (selectedFilterInput == 'fromFilterSelection') {
      filterBody = { 
        filters: { 
          from: fromFilterInput } }
    } 
    else if (selectedFilterInput == 'dateRangeSelection') {
      filterBody = {
        filters: {
          dateRange: {
            fromDate: fromDateInput.replace('T', ' '),
            toDate: toDateInput.replace('T', ' ')
          }
        }
      }
    }
    else if (selectedFilterInput == 'policyNumber') {
      //  Policy Number filter
      filterBody = { filters: { policyNumber: policyNumberInput } }
    }
    else if (selectedFilterInput == 'toMail') {
      // To Mail filter
      filterBody = { filters: { toMail: toMailInput } }
    }

    setFilter(filterBody)
    setFilterApplied(true)
  }

  const isSubmitDisabled = () => {
    switch (selectedFilterInput) {
    case 'fromFilterSelection':
      return fromFilterInput.trim() === ''

    case 'policyNumber':
      return policyNumberInput.trim() === ''

    case 'toMail':
      return toMailInput.trim() === ''

    case 'dateRangeSelection':
      if (!fromDateInput || !toDateInput) {
        return true
      }

      return moment(fromDateInput).isAfter(moment(toDateInput))

    default:
      return true
    }
  }
  // Handle Export CSV
  const handleExportCSV = () => {
    if (onExportCSV && !exportCSV) {
      onExportCSV()
    }
  }
  // Control Export button
  useEffect(() => {
    if (filterApplied && hasResults) {
      setExportCSV(false)
    } else {
      setExportCSV(true)
    }
  }, [filterApplied, hasResults])

  return <div className='filter-section'>
    <Row>
      <Col md={2}> 
        <div className='filter-select'>
          <Form.Select value={selectedFilterInput}
            onChange={(e) => {
              setSelectedFilterInput(e.target.value)
              setFilterApplied(false)
            }}>
            <option value="fromFilterSelection">From</option>
            <option value="dateRangeSelection">Received On</option>
            <option value="policyNumber">Policy Number</option>
            <option value="toMail">To Mail</option>
          </Form.Select>
        </div>
      </Col>

      <Col md={7}>
        <div className='filter-inputs'>
          
          {/* From Filter Input */}
          {selectedFilterInput == 'fromFilterSelection' && <>
            <input
              id="from-filter"
              value={fromFilterInput}
              onChange={({ currentTarget }) => {
                setfromFilterInput(currentTarget.value)
                setFilterApplied(false)
              }}
              placeholder='Filter by sender...'
              type='text'
              className="form-control" />
          </>}

          {/*Date Range Filter Inputs */}
          {selectedFilterInput == 'dateRangeSelection' && <>
            <label htmlFor="start-date">From: </label>
            <input
              value={fromDateInput}
              id="start-date"
              type='datetime-local'
              step={2}
              onChange={({ currentTarget }) => {
                setFilterApplied(false)
                if (currentTarget.value) {
                  let splitArr = currentTarget.value.split('T')
                  if (splitArr[1] && splitArr[1].split(':').length == 2) {
                    setFromDateInput(currentTarget.value + ':00')
                  } else {
                    setFromDateInput(currentTarget.value)
                    
                  }
                }
              }}
              className="form-control" />
            <label htmlFor="end-date">To: </label>
            <input
              id="end-date"
              type='datetime-local'
              onChange={({ currentTarget }) => {
                setFilterApplied(false)
                if (currentTarget.value) {
                  let splitArr = currentTarget.value.split('T')
                  if (splitArr[1] && splitArr[1].split(':').length == 2) {
                    setToDateInput(currentTarget.value + ':00')
                  } else {
                    setToDateInput(currentTarget.value)
                  }
                }
              }}
              value={toDateInput}
              step={2}
              className="form-control" />
          </>}

          {/*Policy Number Filter Input */}
          {selectedFilterInput == 'policyNumber' && <>
            <input
              id="policy-number-filter"
              value={policyNumberInput}
              onChange={({ currentTarget }) => {
                setPolicyNumberInput(currentTarget.value)
                setFilterApplied(false)
              }}
              placeholder='Filter by policy number...'
              type='text'
              className="form-control" />
          </>}

          {/*To Mail Filter Input */}
          {selectedFilterInput == 'toMail' && <>
            <input
              id="to-mail-filter"
              value={toMailInput}
              onChange={({ currentTarget }) => {
                setToMailInput(currentTarget.value)
                setFilterApplied(false)
              }}
              placeholder='Filter by recipient...'
              type='text'
              className="form-control" />
          </>}

        </div>
      </Col>

      <Col md={3}>
        <button
          className={!isSubmitDisabled() ? 'primary-btn search-btn' : 'disabled-btn-filter'}
          disabled={isSubmitDisabled()}
          onClick={handleSubmit}
        >Submit</button>

        <button
          className={!exportCSV ? 'primary-btn search-btn' : 'disabled-btn-export'}
          disabled={exportCSV}
          onClick={handleExportCSV}
        >Export CSV</button>

        <a href=''
          className='reset-filter'
          onClick={(e) => {
            e.preventDefault()
            setfromFilterInput('')
            setPolicyNumberInput('')
            setToMailInput('')
            setFromDateInput('')
            setToDateInput('')
            setFilterApplied(false)
            if (filter && filter.filters) {
              setFilter({})
            }
            
          }}>Reset</a>
      </Col>
    </Row>
  </div>
}

export default MailFilterHistory